import { HTMLAttributes, ReactElement, useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';

export type StyledTableRowProps = {
  variant?: 'default' | 'secondary';
  isSelected?: boolean;
};

export type TableRowProps = {
  initHeight: number;
  children: ReactElement | ReactElement[];
  variant?: 'default' | 'secondary';
} & StyledTableRowProps &
  HTMLAttributes<HTMLTableRowElement>;

const Wrapper = styled.tr<StyledTableRowProps>`
  ${({ onClick }) => onClick && 'cursor: pointer;'}

  & td, & th {
    background-color: ${({ variant = 'default', isSelected, theme }) =>
      theme.color.comp.table.color.bg[isSelected ? 'viewing' : variant].normal};
  }
  tbody:has(td[rowspan]:hover) & td,
  tbody:has(td:not([rowspan]):hover) &:hover td,
  tbody:has(td:not([rowspan]):hover) & td[rowspan] {
    background-color: ${({ variant = 'default', isSelected, theme }) =>
      theme.color.comp.table.color.bg[isSelected ? 'viewing' : variant].hover};
  }
`;

// Temporary virtualized table row component for jamie
export const TempTableVirtualizationWrapper = (props: TableRowProps) => {
  const { children, initHeight, ...restProps } = props;

  const [height, setHeight] = useState(initHeight);

  const { ref, inView } = useInView({
    threshold: 0,
  });

  const listWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const divRefClone = listWrapperRef;

    const resize = new ResizeObserver((entries) => {
      if (inView && entries[0]) {
        const height = entries[0].target?.clientHeight;
        setHeight(height);
      }
    });
    if (divRefClone.current) {
      resize.observe(divRefClone.current);
    }
    return () => {
      if (divRefClone.current) {
        resize.unobserve(divRefClone.current);
      }
    };
  }, [inView]);

  return (
    <Wrapper ref={ref} style={{ height: `${height}px` }} {...restProps}>
      {inView ? children : <></>}
    </Wrapper>
  );
};
